<template>
    <!-- 商品删除 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielDeleteIndex')">
            <template slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="删除时间">
                        <a-range-picker style="width: 100%;" v-decorator="['date']" showTime></a-range-picker>
                    </a-form-item>
                    <a-form-item label="操作人：">
                        <a-input placeholder="请输入" v-decorator="['applyUserName']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="search" :loading="searchLoading">筛选</a-button>
                        <a-button @click="handleReset()" :loading="searchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </template>
            <div class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="goMaterielDeleteApply">商品删除</a-button>
                </div>
                <a-table
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="pagination"
                :rowKey="record => record.id"
                :loading="searchLoading"
                @change="changePage"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}}
                    </template>
                    <template slot="actions" slot-scope="key, row">
                        <a v-if="getBtnByAuth('updateStorage')" class="text-primary" @click="lookDelGoods(row)">删除审批单查看</a>
                        <span v-else class="text-disabled">删除审批单查看</span>
                    </template>
                </a-table>
            </div>
        </content-view>
        <goods-delete-apply-detail-modal ref="goodsDeleteApplyDetailModal"></goods-delete-apply-detail-modal>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import goodsDeleteApplyDetailModal from "@/components/modules/storage/goods-delete-apply-detail-modal.component";
    const columns = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '删除操作时间',
            dataIndex: 'applyTime'
        },
        {
            title: '操作人',
            dataIndex: 'applyUserName',
        },
        {
            title: '操作备注',
            dataIndex: 'remark',
            width: '35%'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    export default {
        name: 'materielDeleteIndex',
        components: {
            goodsDeleteApplyDetailModal
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                searchLoading: false,
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getSelfGoodsRemovePage();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getSelfGoodsRemovePage();
            },
            /**
             * @goMaterielDeleteApply 跳转商品删除
             */
            goMaterielDeleteApply() {
                this.$router.push({name: 'materielDeleteApply'});
            },
            /**
             * @getSelfGoodsRemovePage 商品删除分页
             */
            getSelfGoodsRemovePage() {
                if (!this.shopId || this.searchLoading) {
                    return false;
                }
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.removeTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.removeTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.searchLoading = true;
                    this.$api.newStorage.selfGoodsRemovePage({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        res.data.forEach(item => {
                            item.businessId = item.id;
                        });
                        this.searchLoading = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            this.dataSource = res.data;
                        }
                        this.pagination.total = res.total;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            /**
             * @lookDelGoods 查看删除商品
             */
            lookDelGoods(row) {
                this.$refs.goodsDeleteApplyDetailModal.lookDelGoods(row);
            },
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getSelfGoodsRemovePage();
        },
        watch: {
            '$route'(val) {
                val.name == 'materielDeleteIndex' && this.getSelfGoodsRemovePage();
            },
            'shopId'() {
                this.pagination.current = 1;
                this.getSelfGoodsRemovePage();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
